import React, {
  ComponentType, FunctionComponent, useEffect, useState
} from "react";
import {
  Amplify, Logger, Auth, Hub
} from "aws-amplify";
import Unauthorised from "domains/Misc/Unauthorised";
import useConfig from "hooks/useConfig";

const logger = new Logger("withAuthenticator");

if (process.env.REACT_APP_AMPLIFY_LIVE_MODE !== "false") {
  const config = useConfig();
  const authConfig = {
    Auth: {
      region: config.awsRegion,
      userPoolId: config.userPoolId,
      userPoolWebClientId: config.userPoolClientId,
      mandatorySignIn: true,
      oauth: {
        domain: config.userPoolDomain,
        scope: ["phone", "email", "openid", "profile"],
        redirectSignIn: config.signInUrl,
        redirectSignOut: config.signOutUrl,
        responseType: "code"
      }
    },
    API: {
      endpoints: [
        {
          name: config.defaultEndpointName,
          endpoint: config.apiEndpoint,
          custom_header: async () => ({ Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` })
        }
      ]
    }
  };

  Amplify.configure(authConfig);
}

export function withAuthenticator<T extends object>(
  Component: ComponentType<T>
) {
  const AppWithAuthenticator: FunctionComponent<T> = props => {
    const [signedIn, setSignedIn] = useState(false);
    const [stateConfirmed, setStateConfirmed] = useState(false);
    const [authFailure, setAuthFailure] = useState(false);

    const hubListenerCancelToken = Hub.listen("auth", async ({ payload: { event, data, message } }) => {
      // console.log("event", event);
      // console.log("data", data);
      // console.log("message", message);

      switch (event) {
        case "signIn_failure":
        {
          setAuthFailure(true);
          break;
        }
        default:
          break;
      }
    });

    async function setUser() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        await Auth.currentSession();
        logger.debug(user);
        if (user) setSignedIn(true);
      } catch (err) {
        logger.debug(err);
      } finally {
        setStateConfirmed(true);
      }
    }

    function checkUser() {
      setUser();
    }

    useEffect(() => checkUser(), []);

    useEffect(() => {
      if (authFailure) {
        hubListenerCancelToken();
      }
    }, [authFailure]);

    if (authFailure) {
      return <Unauthorised />;
    }

    if (!stateConfirmed) {
      return <></>; // TODO: Wait Page
    }

    if (!signedIn && !authFailure) {
      Auth.federatedSignIn().then(value => {
        // console.log("logged in");
      });
      return <></>;
    }

    return <Component {...props} />;
  };

  return AppWithAuthenticator;
}
